export const version: string = '1.12.0';
